// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-upload[data-v-28819a2d] {\n  line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
